$(document).ready(function () {

	/* ---------------------------------------- */
	/* ----- >>> Toggle / Switcher ------------ */
	/* ---------------------------------------- */

	$('.setMenu').click(function(){
		$('header nav').toggleClass('isActive');
		$(this).toggleClass('isActive');
	});

	$('nav > ul > li > a[href*="#"]').click(function(e){
		if (!$(this).hasClass('isActive')) {
			$('nav > ul > li > a').removeClass('isActive').next().slideUp('fast');
			$(this).next().slideDown('fast').css('display','flex');
			$(this).addClass('isActive');
		} else {
			$(this).next().slideUp('fast').css('display','flex');
			$(this).removeClass('isActive');
		}
		e.preventDefault();
	});

	$('a[href*="#Find"]').click(function(e){
		$('search').slideToggle('fast')
		e.preventDefault();
	});

	$('a[href*="#Cart"]').click(function(e){
		$('shopping-cart').toggleClass('isActive');
		e.preventDefault();
	});

	$('a[href*="#Close"]').click(function(e){
		$(this).parent().removeClass('isActive')
		e.preventDefault();
	});


	$('.setSelect').click(function(){
		$('ul',this).slideToggle(100)
	});

	/* ---------------------------------------- */

	$(document).mouseup(function(e){
		var isHeader = $('header');
		var isBasket = $('shopping-cart');
		if (!isHeader.is(e.target) && isHeader.has(e.target).length === 0){
			$('.setMenu, nav, header shopping-cart').removeClass('isActive');
			$('search').slideUp(100);
		}
	});

	/* ---------------------------------------- */

	function onChange(trigger, targets) {
		$('#'+trigger).on( "change", function() {
			console.clear();
			console.log('Change');
			console.log(this.value);
			if (this.value != '#') {
				$('#'+ targets + ' li').hide();
				$('#'+ targets + ' li[data-city="'+this.value+'"]').show();
			} else {
				$('#'+ targets + ' li').show();
			}
		});
	}

	onChange('getStore', 'setStore');

	/* ---------------------------------------- */
	/* ----- >>> Stick Header ----------------- */
	/* ---------------------------------------- */

	/* 
	var setScroll = $(window).scrollTop();

	$(window).scroll(function() {
		var setStatus = $(window).scrollTop();
		var setLimits = $(window).height() / 4;

		if (setScroll < setLimits) {
			$('header').removeClass('isAlt');
		} else {
			$('header').addClass('isAlt');
		}
		if($(window).width() > 640) {
			if (setScroll < 100 || setScroll > setStatus ) { 
				$('header').removeClass('onTop');
			} else {
				$('header').addClass('onTop');
			}
		}
		setScroll = setStatus;
	});

	/* ---------------------------------------- */
	/* ----- >>> Slide Content ---------------- */
	/* ---------------------------------------- */

	$('swiper').each( function(ID,value) {
		var getMin			= $(this).data('min');
		var getMax			= $(this).data('max');
		var getGap			= $(this).data('gap');
		var getLoop			= $(this).data('loop');
		var getSlide		= $(this).data('slide');
		var getCenter		= $(this).data('center');
		var getAutoplayDelay = $(this).data('autoplay-delay') || 3000;

						$(this).addClass('isS000'+ID);
		$('.setPrev', this).addClass('isP000'+ID);
		$('.setNext', this).addClass('isN000'+ID);
		$('.setDots', this).addClass('isD000'+ID);

		const swiper = new Swiper('.isS000'+ID, {
			centeredSlidesBounds		: false,
			slideToClickedSlide		: true,
			cssWidthAndHeight 		: true,
			centeredSlides				: getCenter,
			allowTouchMove				: true,
			slidesPerView				: getMin,
			spaceBetween				: getGap,
			loop							: getLoop,
			autoplay: getSlide ? { delay: getAutoplayDelay } : false,
			navigation				  	: {
				prevEl					: '.isP000'+ID,
				nextEl					: '.isN000'+ID,
			},
			pagination					: {
				bulletActiveClass		: 'isActive',
				el							: '.isD000'+ID,
				bulletClass				: 'setDot',
				clickable				: true
			},
			breakpoints					: {
				640: {
					centeredSlides		: true,
					slidesPerGroup		: getMin,
					slidesPerView		: getMin,
					spaceBetween		: getGap,
				},
				1024: {
					centeredSlides		: false,
					slidesPerGroup		: getMax,
					slidesPerView		: getMax,
					spaceBetween		: getGap,
				}
			}
		});
	});

	$('dl > dt').on('click', function () {
		if (!$(this).hasClass('isActive')) {
			$(this).parent().children('dd').slideUp('fast');
			$('dl > dt').removeClass('isActive');
			$(this).addClass('isActive').next().slideDown('fast');
		} else {
			$(this).parent().children('dd').slideUp('fast');
			$('dl > dt').removeClass('isActive');
		}
		return false;
	});
    
	/* ---------------------------------------- */
	/* ----- >>> Product Actions -------------- */
	/* ---------------------------------------- */

	$('.isL').click( function() {
		var setInput = $(this).parent().find('.isQ')
		var setLimit = setInput.attr('min');
		var setValue = +setInput.val() - 1
		if ( setValue >= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})

	$('.isM').click( function() {
		var setInput = $(this).parent().find('.isQ')
		var setLimit = setInput.attr('max');
		var setValue = +setInput.val() + 1
		if ( setValue <= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})

	/* ---------------------------------------- */
	/* ----- >>> Mailto Links ----------------- */
	/* ---------------------------------------- */

	var links = document.links;
	for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

});